export default [
  {
    path: "/accounts",
    component: () => import(/* webpackChunkName: "accounts" */ "./layout.vue"),

    children: [
      {
        path: "/mobilemoney",
        name: "mobilemoney.index",
        component: () => import(/* webpackChunkName: "mobilemoney.index" */ "./mobilemoney/all"),
      },

      {
        path: "mobilemoney/:id",
        props: true,
        name: "mobilemoney.show",
        component: () => import(/* webpackChunkName: "mobilemoney.show" */ "./mobilemoney/show"),
      },
      {
        path: "bankaccounts",
        name: "bankaccounts.index",
        component: () =>
          import(/* webpackChunkName: "bankaccounts.index" */ "./bankaccounts/index"),
      },
      {
        path: "bankaccounts/:id",
        props: true,
        name: "bankaccounts.show",
        component: () => import(/* webpackChunkName: "bankaccounts.show" */ "./bankaccounts/show"),
      },
    ],
  },
];
